import {
  RecognitionWaterfallKind,
  RecognitionWaterfallOrdering,
} from "store/apis/recognitionWaterfall";

export const EXPENSE_KIND: RecognitionWaterfallKind = "EXPENSE";

export type WaterfallLabels = {
  party: string;
  recognized: string;
  category: string;
  linkedDocument: string;
  documentPath: (documentId: string) => string;
  documentDate: string;
  documentSingular: string;
  documentPlural: string;
  search: string;
};

export const LABELS: Record<RecognitionWaterfallKind, WaterfallLabels> = {
  REVENUE: {
    party: "Customer",
    recognized: "Revenue",
    category: "Income",
    linkedDocument: "Linked Invoice",
    documentPath: (documentId) => `/books/invoices-and-customers/${documentId}`,
    documentDate: "Invoice date",
    documentSingular: "invoice",
    documentPlural: "invoices",
    search: "Search customer or invoice number",
  },
  EXPENSE: {
    party: "Vendor",
    recognized: "Expense",
    category: "Expense",
    linkedDocument: "Linked Bill",
    documentPath: (documentId) => `/books/bills-and-vendors/bill/${documentId}`,
    documentDate: "Bill date",
    documentSingular: "bill",
    documentPlural: "bills",
    search: "Search vendor or bill number",
  },
};

export const PAGE_QUERY_KEY = "page";
export const PAGE_SIZE_QUERY_KEY = "page_size";
export const DEFAULT_PAGE_SIZE = 20;
// Each customer row nests its invoices and items, so larger pages get slow
export const MAX_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [20, 50, 75, MAX_PAGE_SIZE].map(
  (pageSize) => ({ label: `${pageSize} items`, value: String(pageSize) })
);
export const PAGE_SIZE_MENU_STYLES = { menu: () => ({ width: "100px" }) };

export const CUSTOM_PERIOD = "CUSTOM";
export const PERIOD_FILTER = "PERIOD";

export const UNKNOWN_PARTY_ROW_ID = "unknown";
export const TOTAL_ROW_ID = "total";
export const EMPTY_CELL = "—";
export const LINE_ITEM_FALLBACK_LABEL = "Line item";

// "Recognised", as the Revenue Waterfall spells it
export const PRIOR_HINT = "Already recognised before the selected period";

export const NOOP = () => {};

export const DESCENDING_PREFIX = "-";
export const PERIOD_COLUMN_PREFIX = "period_";

// Opens on the biggest customers/vendors first
export const DEFAULT_ORDERING: RecognitionWaterfallOrdering = "-scheduled";
